import { Link } from 'react-router-dom';
import styles from './LandingPage.module.css';

export const LandingPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <h1>REFUGE</h1>
          <p className={styles.subtitle}>EMPLOYEE SCANNER APP</p>
        </div>

        <div className={styles.buttonGroup}>
          <Link to="/admin/login" className={styles.adminButton}>
            <span className={styles.buttonIcon}>▶</span>
            <span className={styles.buttonText}>ADMIN LOGIN</span>
          </Link>

          <Link to="/employee/login" className={styles.employeeButton}>
            <span className={styles.buttonIcon}>▶</span>
            <span className={styles.buttonText}>EMPLOYEE LOGIN</span>
          </Link>
        </div>

        <div className={styles.footer}>
          <p>Select your access type to continue</p>
        </div>
      </div>
    </div>
  );
};
